<p-dialog id="RenameDlg"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '30vw', height: '50hw'}">

  <ng-template pTemplate="content">
    <div class="grid">
      <div class="col-12 mt-6">
        <span class="p-float-label">
          <input id="smtng-input" type="text" (keyup.enter)="doConfirm($event)" pInputText [(ngModel)]="textToRename" style="width:100%">
          <label for="float-input">{{inputLabel}}</label>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')" [disabled]="!canConfirm"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
